import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../lib/domain';
import { Button, Alert, notification } from 'antd';
import Title from 'antd/lib/typography/Title';
import Form from '../../lib/ui/form';
import { withRouter } from 'react-router-dom';


const queryString = require('query-string');


const change_pw_fields = [
    {
        index: 'current_password',
        name: "Current Password",
        type: 'password'
    },
    {
        index: 'new_password',
        name: "New Password",
        type: 'password'
    },
    {
        index: 'confirm_password',
        name: "Confirm Password",
        type: 'password'
    }
]
class ChangePasswordView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            form_data: {},
            submitted: false,
            check_data:{}
        }

        this.change_password = RESTExecutor.post().config({
            label: 'change_password'
        }).callbacks((success) => {
            notification.success({
                message:"Password Updated",
                description:"Please login again with new password."
            })
            try{
                props.authenticator.initializer()
              }catch(e){
              }
            // props.authenticator.persistTokens(props.authenticator.auth_token_response_formatter(success));
            // this.props.history.push('/dashboard')
        }, (error) => { }).connect(props.domains.profile)
    }

    render() {
        let change_password_resp = this.change_password.response();
        const {check_data}=this.state;
        const { authenticator } = this.props;
        let meta = authenticator.getTokens().meta || {};
        let user = meta.user_data || {};

        return (
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                height: 'calc(100vh - 64px)'
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    height: '100%'
                }}>
                    <div className='default-card' style={{ padding: 40, width: 400 }}>

                        <Title style={{ margin: 0, marginBottom: 6 }}>Change Password</Title>
                        {check_data.is_first=='true'&&check_data.is_expired!='true'&&
                        <Alert style={{
                            marginBottom:10
                        }} message={<div>Welcome <b> {user.name} </b>. Please change your default password set by system admin. </div>} type="info" />
                        }
                         {check_data.is_expired=='true'&&
                        <Alert  style={{
                            marginBottom:10
                        }} message={<div>Your password has been expired. Please update your password to continue</div>} type='error' />
                        }
                        

                        <Form
                            forCreate={true}
                            initialData={this.state.form_data}
                            submitted={this.state.submitted}
                            onChange={(form_data) => { this.setState({ form_data: form_data, submitted: false }) }}
                            fields={change_pw_fields}
                            // submitting={ change_password_resp.fetching}
                            errorMessage={change_password_resp.error_message}
                            validationErrors={change_password_resp.validation_errors}
                        />
                        <Button type='primary' style={{ marginTop: 16 }} block
                            loading={change_password_resp.fetching}
                            disabled={change_password_resp.fetching}
                            onClick={() => {
                                this.setState({ submitted: true })
                                this.change_password.execute(this.state.form_data)
                            }}
                        >Submit</Button>

                        <Button type='danger' style={{ marginTop: 16 }} block
                            // loading={change_password_resp.fetching}
                            // disabled={change_password_resp.fetching}
                            onClick={() => {
                                // this.setState({ submitted: true })
                                // this.change_password.execute(this.state.form_data)
                                this.props.authenticator.logout()
                            }}
                        >Logout</Button>
                    </div>

                </div>
            </div>
        );
    }
    componentDidMount() {
        if (this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            console.log("filter data", parsed)
            this.setState({
                check_data: parsed
            }
            )
        }
    }

    componentWillReceiveProps(nextProps) {
        // console.log("Changed state before", nextProps.location)

        if (this.props.location) {

            if (this.props.location.search !== nextProps.location.search) {
                const parsed = queryString.parse(nextProps.location.search);
                console.log("filter data", parsed)
                this.setState({
                    check_data: parsed,
                });


            }
        }
    }


}

export default withRouter(withDomains(ChangePasswordView, "profile", "adminAuth"));
